import { Button } from '@components/Button'
import { Pill } from '@components/Pill'
import type { MyJoinRequestCard } from '@lib/joinRequests'
import React from 'react'
import { RequestCard, RequestCardText, RequestCardTop, RequestLine, RequestTripName } from './JoinRequestCards.styles'

interface JoinRequestCardsProps {
	requests: MyJoinRequestCard[]
	/** Cancels a pending request (after asking) or dismisses a denied one. */
	onWithdraw: (request: MyJoinRequestCard) => void
	/** The code whose withdrawal is in flight, if any. */
	withdrawingCode?: string | null
}

/**
 * My Join requests, pending and denied, as the first cards in my trips grid — as
 * iOS lists them first among the trips. Each leads with its state, the refusal
 * the stronger of the two as on iOS: "Requested" warm, "Not approved" in red.
 */
const JoinRequestCards: React.FC<JoinRequestCardsProps> = ({ requests, onWithdraw, withdrawingCode }) => (
	<>
		{requests.map(request => (
			<RequestCard key={request.code} aria-label={`${request.status}: ${request.tripName}`}>
				<RequestCardTop>
					<Pill $size="sm" $tone={request.isPending ? 'soft' : 'danger'}>
						{request.status}
					</Pill>
					<Button
						type="button"
						variant="secondary"
						size="sm"
						aria-label={request.actionAriaLabel}
						disabled={withdrawingCode === request.code}
						onClick={() => onWithdraw(request)}
					>
						{request.actionLabel}
					</Button>
				</RequestCardTop>
				<RequestCardText>
					<RequestTripName>{request.tripName}</RequestTripName>
					{request.meta && <RequestLine>{request.meta}</RequestLine>}
					{request.detail && <RequestLine>{request.detail}</RequestLine>}
				</RequestCardText>
			</RequestCard>
		))}
	</>
)

export default JoinRequestCards
